export var GetDPDetailsByDPIdMapper = function (data) {
    var result = {};
    if (data) {
        result = {
            dpid: data.dpid,
            dpAcNo: data.dpAcNo,
            dpName: data.dpName,
            name_H1: data.name_H1,
            address_H1: data.address_H1,
            pan_H1: data.pan_H1,
            emailID_H1: data.emailID_H1,
            phone_H1: data.phone_H1,
            name_H2: data.name_H2,
            pan_H2: data.pan_H2,
            emailID_H2: data.emailID_H2,
            mobile_H2: data.mobile_H2,
            name_H3: data.name_H3,
            pan_H3: data.pan_H3,
            emailID_H3: data.emailID_H3,
            mobile_H3: data.mobile_H3,
            name_NmDetails: data.name_NmDetails,
            address_NmDetails: data.address_NmDetails,
            bankName: data.bankName,
            accountNo: data.accountNo,
            micr: data.micr,
            address: data.address,
            neftCode: data.neftCode,
            clientDPType: data.clientDPType &&
                data.clientDPType.length != 0 &&
                data.clientDPType.map(function (item) {
                    return {
                        type: item.type,
                        amount: item.amount,
                    };
                }),
        };
    }
    return result;
};
